import Table from 'react-bootstrap/Table'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import OperatorsApiManager from '../../api/services/OperatorsApiManager'
import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import AuthApiManager from '../../api/services/AuthApiManager'
import { useTranslation } from 'react-i18next'
import useIsMobile from '../../hooks/useIsMobile'

function Operators() {
    const navigate = useNavigate()
    const isMobile = useIsMobile()
    const { t } = useTranslation()
    const [operadores, setOperadores] = useState([])
    const [hasPermission, setHasPermission] = useState(false)
    const [selectedOperator, setSelectedOperator] = useState(null)
    const [operadoresData, setOperadoresData] = useState([])
    const [operadoresMobile, setOperadoresMobile] = useState([])
    const handleClickOperator = (event, operador) => {
        event.preventDefault()
        var operatorToSave = {
            group_id: operador.operador,
            group_name: operador.nombre_operador,
            role: operador.group_roles,
        }
        localStorage.setItem('operador', JSON.stringify(operatorToSave))
        toast.success(t('alerts.operator_mark_current'))
        navigate('/operadores')
    }
    const handleShowBanners = (event, operador) => {
        event.preventDefault()
        var operatorToSave = {
            group_id: operador.operador,
            group_name: operador.nombre_operador,
            role: operador.group_roles,
        }
        localStorage.setItem('operador', JSON.stringify(operatorToSave))
        navigate('/operadores/banners')
    }
    const handleShowChannels = (event, operador) => {
        event.preventDefault()
        var operatorToSave = {
            group_id: operador.operador,
            group_name: operador.nombre_operador,
            role: operador.group_roles,
        }
        localStorage.setItem('operador', JSON.stringify(operatorToSave))
        navigate('/operadores/canales')
    }
    const handleShowUsers = (event, operador) => {
        event.preventDefault()
        var operatorToSave = {
            group_id: operador.operador,
            group_name: operador.nombre_operador,
            role: operador.group_roles,
        }
        localStorage.setItem('operador', JSON.stringify(operatorToSave))
        navigate('/operadores/usuarios')
    }

    useEffect(() => {
        setHasPermission(AuthApiManager.hasPermission('Operador'))
        var operatorData = localStorage.getItem('operador')
        var operator = JSON.parse(operatorData)
        setSelectedOperator(operator)
        const getBannersCount = (operator, operadoresCounts) => {
            const op = operadoresCounts.find(
                (x) => x.group_id === operator.operador
            )
            return op?.content_count?.banner
        }
        const getUsersCount = (operator, operadoresCounts) => {
            const op = operadoresCounts.find(
                (x) => x.group_id === operator.operador
            )
            return op?.num_users
        }
        const getChannelsCount = (operator, operadoresCounts) => {
            const op = operadoresCounts.find(
                (x) => x.group_id === operator.operador
            )
            return op?.content_count?.channel
        }
        const hasPermissionInOperator = (operator) => {
            return operator?.group_roles.includes('Operador')
        }
        async function fetchOperadores() {
            const hasPer = AuthApiManager.hasPermission('Operador')
            let operadoresCounts = []
            try {
                operadoresCounts = await OperatorsApiManager.getUserOperators()
            } catch (err) {
                //console.error(err)
            }

            const operadoresV1Items =
                await OperatorsApiManager.getUserOperatorsV1()
            setOperadoresData(operadoresV1Items)

            const operadoresMobile = operadoresV1Items.map((operador) => (
                <div key={operador.operador} className="cardM mb-2 p-2">
                    {hasPermission && (<div>
                        <strong>ID: </strong>{' '}
                        {operador.operador}
                    </div>)}
                    <div>
                        {operador.nombre_operador}
                    </div>
                    {hasPermission && (<div>
                        <strong>{t('channels_title')}:</strong>{' '}
                        {getChannelsCount(operador, operadoresCounts)}
                    </div>)}
                    {hasPermission && (<div>
                        <strong>{t('banners_title')}:</strong>{' '}
                        {getBannersCount(operador, operadoresCounts)}
                    </div>)}
                    {hasPermission && (<div>
                        <strong>{t('users_title')}:</strong>{' '}
                        {getUsersCount(operador, operadoresCounts)}
                    </div>)}
                    <div className="mt-2">

                        <div className="col">
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        {t('show_channels')}
                                    </Tooltip>
                                }
                            >
                                <span className="d-inline-block">
                                    <Button variant="btn-rounded outline-secondary  btn-icon">
                                        <i
                                            className="mdi mdi-layers btn-icon-prepend text-primary"
                                            onClick={(event) =>
                                                handleShowChannels(
                                                    event,
                                                    operador
                                                )
                                            }
                                        ></i>
                                    </Button>
                                </span>
                            </OverlayTrigger>

                            {hasPermissionInOperator(operador) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {t('show_banners')}
                                        </Tooltip>
                                    }
                                >
                                    <span className="d-inline-block">
                                        <Button variant="btn-rounded outline-secondary btn-icon">
                                            <i
                                                className="mdi mdi-projector-screen-variant-outline btn-icon-prepend text-dark"
                                                onClick={(event) =>
                                                    handleShowBanners(
                                                        event,
                                                        operador
                                                    )
                                                }
                                            ></i>
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                            )}
                            {hasPermissionInOperator(operador) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {t('show_users')}
                                        </Tooltip>
                                    }
                                >
                                    <span className="d-inline-block">
                                        <Button
                                            variant="btn-rounded outline-secondary btn-icon"
                                            onClick={(event) =>
                                                handleShowUsers(event, operador)
                                            }
                                        >
                                            <i className="mdi mdi-account-group text-info btn-icon-prepend"></i>
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                            )}

                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        {t('mark_current')}
                                    </Tooltip>
                                }
                            >
                                <span className="d-inline-block">
                                    <Button
                                        variant="btn-rounded outline-secondary btn-icon"
                                        onClick={(event) =>
                                            handleClickOperator(event, operador)
                                        }
                                    >
                                        <i className="mdi mdi-star-box btn-icon-prepend text-primary"></i>
                                    </Button>
                                </span>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
            ))
            const operadores = operadoresV1Items.map((operador) => (
                <tr key={operador.operador}>
                    <td>
                        <div>{operador.operador}</div>
                    </td>
                    <td>{operador.nombre_operador}</td>
                    <td>{getChannelsCount(operador, operadoresCounts)}</td>
                    <td>{getBannersCount(operador, operadoresCounts)}</td>
                    <td>{getUsersCount(operador, operadoresCounts)}</td>
                    <td>
                        <div className="col">
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        {t('show_channels')}
                                    </Tooltip>
                                }
                            >
                                <span className="d-inline-block">
                                    <Button variant="btn-rounded outline-secondary  btn-icon">
                                        <i
                                            className="mdi mdi-layers btn-icon-prepend text-primary"
                                            onClick={(event) =>
                                                handleShowChannels(
                                                    event,
                                                    operador
                                                )
                                            }
                                        ></i>
                                    </Button>
                                </span>
                            </OverlayTrigger>

                            {hasPermissionInOperator(operador) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {t('show_banners')}
                                        </Tooltip>
                                    }
                                >
                                    <span className="d-inline-block">
                                        <Button variant="btn-rounded outline-secondary btn-icon">
                                            <i
                                                className="mdi mdi-projector-screen-variant-outline btn-icon-prepend text-dark"
                                                onClick={(event) =>
                                                    handleShowBanners(
                                                        event,
                                                        operador
                                                    )
                                                }
                                            ></i>
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                            )}
                            {hasPermissionInOperator(operador) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {t('show_users')}
                                        </Tooltip>
                                    }
                                >
                                    <span className="d-inline-block">
                                        <Button
                                            variant="btn-rounded outline-secondary btn-icon"
                                            onClick={(event) =>
                                                handleShowUsers(event, operador)
                                            }
                                        >
                                            <i className="mdi mdi-account-group text-info btn-icon-prepend"></i>
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                            )}

                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        {t('mark_current')}
                                    </Tooltip>
                                }
                            >
                                <span className="d-inline-block">
                                    <Button
                                        variant="btn-rounded outline-secondary btn-icon"
                                        onClick={(event) =>
                                            handleClickOperator(event, operador)
                                        }
                                    >
                                        <i className="mdi mdi-star-box btn-icon-prepend text-primary"></i>
                                    </Button>
                                </span>
                            </OverlayTrigger>
                        </div>
                    </td>
                </tr>
            ))

            setOperadores(operadores)
            setOperadoresMobile(operadoresMobile)
        }

        fetchOperadores()
    }, [])

    return (
        <div>
            <ToastContainer />
            <div className="page-header">
                <h3 className="page-title">{selectedOperator?.group_name}</h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li
                            className="breadcrumb-item active"
                            aria-current="page"
                        >
                            {t('operators_title')}
                        </li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-4">
                                <h4 className="card-title col-md-6">
                                    {t('operators_title')}
                                </h4>
                                <div className={isMobile ? "col-12 text-left mb-2" : "col-md-6 text-right text-center"}>
                                    <span className="text-muted">
                                        {t('operators_count')}
                                        <strong>{operadoresData.length}</strong>
                                    </span>
                                </div>
                            </div>
                            <div className="table-responsive">
                                {isMobile ? (
                                    <div>{operadoresMobile}</div>
                                ) : (
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>{t('name_title')}</th>
                                                <th>{t('channels_title')}</th>
                                                <th>{t('banners_title')}</th>
                                                <th>{t('users_title')}</th>
                                                <th>{t('options_title')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>{operadores}</tbody>
                                    </Table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Operators
